const CommonApiUrl = {
    //#region Common
    GetListValue: "api/Common/GetListValue",
    GetListValueUI: "api/CommonUI/GetListValue",
    //#endregion

    //#region Common
    UploadImage: "api/Images/UploadImages",
    DeleteImageById: "api/Images/DeleteImagesByReferenceId",
    UpdateImageById: "api/Images/UpdateImagesByReferenceId",
    //#endregion

    //#region Company
    GetCompanyDetails: "api/Common/GetCompanyDetails",
    UpdateCompanyDetails: "api/Common/UpdateCompanyDetails",
    //#endregion
}
export default CommonApiUrl;